/**
 * created by evan on 2019-10-11
 * API业务参数对象
 */
const apis = {
  // example
  apiGet: {
    url: '',
    method: 'get',
    type: 'url',
    params: {}
  },
  apiPost: {
    url: '',
    method: 'post',
    type: 'json',
    params: {}
  },
  auth: {
    url: '/auth',
    method: 'post',
    type: 'json',
    params: {
    }
  },
  login: {
    url: '/auth/login',
    method: 'post',
    type: 'json',
    params: {
    }
  },
  verifyCode: {
    url: '/auth/verify_code',
    method: 'post',
    type: 'json',
    params: {
    }
  },
  codeLogin: {
    url: '/auth/code_login',
    method: 'post',
    type: 'json',
    params: {
    }
  },
  getActivity: {
    url: '/v1/ocean/open/activity/get',
    method: 'get',
    type: 'url',
    params: {}
  },
  getActivityPublic: {
    url: '/v1/ocean/public/activity/get',
    method: 'get',
    type: 'url',
    params: {}
  },
  wxSignature: {
    url: '/v1/ocean/public/wx/sdk/signature',
    method: 'post',
    type: 'json',
    params: {
    }
  },
  statisticsSeemsgSave: {
    url: '/v1/ocean/public/statistics/seemsg/save',
    method: 'post',
    type: 'json',
    params: {
    }
  },
  statisticsSouristDel: {
    url: '/v1/ocean/public/statistics/tourist/del',
    method: 'post',
    type: 'json',
    params: {
    }
  },
  statisticsCollectDel: {
    url: '/v1/ocean/public/statistics/collect/del',
    method: 'post',
    type: 'json',
    params: {
    }
  }
}

export default apis
